import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import './ContactPage.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'success' or 'error'

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setSubmitMessage('');
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://api.345.tr'}/main/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok) {
        setSubmitMessage(result.message);
        setMessageType('success');
        // Formu temizle
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      } else {
        setSubmitMessage(result.message || 'Bir hata oluştu');
        setMessageType('error');
      }
    } catch (error) {
      console.error('Form gönderme hatası:', error);
      setSubmitMessage('Bağlantı hatası. Lütfen daha sonra tekrar deneyin.');
      setMessageType('error');
    } finally {
      setIsLoading(false);
      // Mesajı 5 saniye sonra temizle
      setTimeout(() => {
        setSubmitMessage('');
        setMessageType('');
      }, 5000);
    }
  };

  return (
    <div className="contact-page-wrapper">
      <Helmet>
        <title>Randevu345 - İletişim | 7/24 Destek Hattı</title>
        <meta name="description" content="Randevu345 ile iletişime geçin. 7/24 destek hattı: 0850 307 0 345. Sorularınız, önerileriniz veya destek talepleriniz için bizimle iletişime geçin." />
        <meta name="keywords" content="randevu345 iletişim, randevu345 destek, salon yönetimi destek, kuaför programı yardım, randevu sistemi destek" />
        <link rel="canonical" href="https://345.com.tr/contact" />
        
        {/* Open Graph */}
        <meta property="og:title" content="Randevu345 - İletişim | 7/24 Destek Hattı" />
        <meta property="og:description" content="Randevu345 ile iletişime geçin. 7/24 destek hattı: 0850 307 0 345. Sorularınız için bizimle iletişime geçin." />
        <meta property="og:url" content="https://345.com.tr/contact" />
        
        {/* Twitter */}
        <meta name="twitter:title" content="Randevu345 - İletişim | 7/24 Destek Hattı" />
        <meta name="twitter:description" content="Randevu345 ile iletişime geçin. 7/24 destek hattı: 0850 307 0 345. Sorularınız için bizimle iletişime geçin." />
      </Helmet>
      {/* Hero Section */}
      <section className="contact-hero-section">
        <div className="contact-container">
          <div className="contact-hero-content">
            <h1 className="contact-hero-title">
              Bizimle 
              <span className="contact-gradient-text"> İletişime Geçin</span>
            </h1>
            <p className="contact-hero-description">
              Sorularınız, önerileriniz veya destek talepleriniz için 7/24 hizmetinizdeyiz. 
              Size en uygun iletişim kanalını seçin.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content-section">
        <div className="contact-container">
          <div className="contact-content-grid">
            
            {/* Contact Info */}
            <div className="contact-info-wrapper">
              <div className="contact-info-header">
                <h2 className="contact-info-title">İletişim Bilgileri</h2>
                <p className="contact-info-subtitle">
                  Aşağıdaki kanallardan bize ulaşabilirsiniz
                </p>
              </div>

              <div className="contact-info-list">
                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <span>📍</span>
                  </div>
                  <div className="contact-info-content">
                    <h3>Adres</h3>
                    <p>
                      Yakuplu Mah. Hürriyet Bulvarı<br />
                      Skyport Residence No:1 D:75<br />
                      Beylikdüzü, İstanbul
                    </p>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <span>📞</span>
                  </div>
                  <div className="contact-info-content">
                    <h3>Telefon</h3>
                    <p>
                      <a href="tel:+908503070345" className="contact-phone-link">
                        0850 307 0 <span className="contact-phone-highlight">345</span>
                      </a>
                    </p>
                    <span className="contact-phone-note">7/24 Destek Hattı</span>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <span>✉️</span>
                  </div>
                  <div className="contact-info-content">
                    <h3>E-posta</h3>
                    <p>
                      <a href="mailto:randevu@345.com.tr" className="contact-email-link">
                        randevu@345.com.tr
                      </a>
                    </p>
                    <span className="contact-email-note">24 saat içinde yanıt</span>
                  </div>
                </div>

                <div className="contact-info-item">
                  <div className="contact-info-icon">
                    <span>⏰</span>
                  </div>
                  <div className="contact-info-content">
                    <h3>Çalışma Saatleri</h3>
                    <p>
                      Pazartesi - Pazar<br />
                      24 Saat Hizmet
                    </p>
                    <span className="contact-hours-note">Kesintisiz destek</span>
                  </div>
                </div>
              </div>

              {/* Quick Actions */}
              <div className="contact-quick-actions">
                <h3 className="contact-quick-title">Hızlı İletişim</h3>
                <div className="contact-quick-buttons">
                  <a 
                    href="tel:+908503070345" 
                    className="contact-quick-button phone"
                  >
                    <span className="contact-quick-icon">📞</span>
                    Hemen Ara
                  </a>
                  <a 
                    href="mailto:randevu@345.com.tr" 
                    className="contact-quick-button email"
                  >
                    <span className="contact-quick-icon">✉️</span>
                    E-posta Gönder
                  </a>
                  <a 
                    href="https://wa.me/908503070345" 
                    className="contact-quick-button whatsapp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span className="contact-quick-icon">💬</span>
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-wrapper">
              <div className="contact-form-header">
                <h2 className="contact-form-title">Mesaj Gönderin</h2>
                <p className="contact-form-subtitle">
                  Formu doldurun, size en kısa sürede dönüş yapalım
                </p>
              </div>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <label htmlFor="name" className="contact-form-label">
                      Ad Soyad *
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      className="contact-form-input"
                      required
                      placeholder="Adınız ve soyadınız"
                    />
                  </div>
                  <div className="contact-form-group">
                    <label htmlFor="email" className="contact-form-label">
                      E-posta *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="contact-form-input"
                      required
                      placeholder="ornek@email.com"
                    />
                  </div>
                </div>

                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <label htmlFor="phone" className="contact-form-label">
                      Telefon
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="contact-form-input"
                      placeholder="0555 123 45 67"
                    />
                  </div>
                  <div className="contact-form-group">
                    <label htmlFor="subject" className="contact-form-label">
                      Konu *
                    </label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      className="contact-form-select"
                      required
                    >
                      <option value="">Konu seçin</option>
                      <option value="demo">Demo Talebi</option>
                      <option value="support">Teknik Destek</option>
                      <option value="sales">Satış Danışmanlığı</option>
                      <option value="billing">Faturalama</option>
                      <option value="feature">Özellik Önerisi</option>
                      <option value="other">Diğer</option>
                    </select>
                  </div>
                </div>

                <div className="contact-form-group">
                  <label htmlFor="message" className="contact-form-label">
                    Mesajınız *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    className="contact-form-textarea"
                    rows="6"
                    required
                    placeholder="Mesajınızı buraya yazın..."
                  ></textarea>
                </div>

                {submitMessage && (
                  <div className={`contact-form-message ${messageType}`}>
                    {submitMessage}
                  </div>
                )}

                <button 
                  type="submit" 
                  className="contact-form-submit"
                  disabled={isLoading}
                >
                  {isLoading ? 'Gönderiliyor...' : 'Mesaj Gönder'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="contact-map-section">
        <div className="contact-container">
          <div className="contact-map-header">
            <h2 className="contact-map-title">
              Ofis <span className="contact-gradient-text">Konumumuz</span>
            </h2>
            <p className="contact-map-subtitle">
              Beylikdüzü merkezinde, ulaşımı kolay konumumuzda sizleri bekliyoruz
            </p>
          </div>
          
          <div className="contact-map-wrapper">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3013.0234567890123!2d28.661030500967076!3d41.007309312581725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDAwJzI2LjMiTiAyOMKwMzknMzkuNyJF!5e0!3m2!1str!2str!4v1234567890123"
              className="contact-map-iframe"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Randevu345 Ofis Konumu"
            ></iframe>
            
            <div className="contact-map-overlay">
              <div className="contact-map-info">
                <h3>Randevu345 Ofisi</h3>
                <p>Yakuplu Mah. Hürriyet Bulvarı<br />Skyport Residence No:1 D:75</p>
                <a 
                  href={`https://www.google.com/maps?q=41.007309312581725,28.661030500967076`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-map-button"
                >
                  Yol Tarifi Al
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage; 